import { useRoot } from '-app/root'

export const usePrintWatchModel = () => {
  const { printWatch } = useRoot()

  return printWatch
}
